import { UserRole } from "@prisma/client";

/**
 * Where each role should land right after signing in — the admin area each
 * role actually works in day to day, not the shared /admin analytics root.
 * ADMIN/MANAGER see everything (see ENGAGEMENT_ROLES) so they go to the main
 * core-services screen; CUSTOMER_SUPPORT is scoped to engagement; AUTHOR is
 * scoped to articles (see middleware.ts's roleNotAllowedRoutes for the
 * matching access gate).
 */
const ROLE_REDIRECTS: Record<UserRole, string> = {
  ADMIN: "/admin/core-services",
  MANAGER: "/admin/core-services",
  CUSTOMER_SUPPORT: "/admin/engagement",
  AUTHOR: "/admin/articles",
  USER: "/dashboard/messages",
};

export function getPostLoginRedirect(role?: UserRole | string | null): string {
  if (role && role in ROLE_REDIRECTS) {
    return ROLE_REDIRECTS[role as UserRole];
  }
  return "/dashboard/messages";
}
